import { render, staticRenderFns } from "./chat-content-scroll.vue?vue&type=template&id=13d2feee&scoped=true&"
import script from "./chat-content-scroll.vue?vue&type=script&lang=js&"
export * from "./chat-content-scroll.vue?vue&type=script&lang=js&"
import style0 from "./chat-content-scroll.vue?vue&type=style&index=0&id=13d2feee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d2feee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13d2feee')) {
      api.createRecord('13d2feee', component.options)
    } else {
      api.reload('13d2feee', component.options)
    }
    module.hot.accept("./chat-content-scroll.vue?vue&type=template&id=13d2feee&scoped=true&", function () {
      api.rerender('13d2feee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chatLog/lib/chat-content-scroll.vue"
export default component.exports